import react,{Component} from 'react';
import { DKLabel, DKButton,showToast,TOAST_TYPE, DKSpinner,DKCalendar,DKIcon,DKIcons,DKLine,DKInput,INPUT_VIEW_DIRECTION,Toggle, showLoader, removeLoader } from "deskera-ui-library";
import RouteManager from '../../../../managers/RouteManager';
import date_range from "../../../../assets/icons/white/date_range.svg";
import moment from 'moment';
import {  INPUT_TYPE } from '../../../../constants/Constant';
import ReportService from '../../../../services/ReportService';
import { saveAs } from 'file-saver';
import { TENANT, TenantService } from '../../../../managers/TenantManagerService';
import DataGridHolderPayroll from '../../../common/DataGridHolderPayroll';
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from '../../../../managers/TableManger';
import {  getFileName, parseColumnConfig, parseVisibleColumnConfig, prepareRowDataForm16 } from '../../../configs/config';
import AttachmentService from '../../../../services/AttachmentService';
import ic_info_warning from "../../../../assets/icons/ic_info_gray.svg";
import i18next from 'i18next';
import Utility, { deepClone } from '../../../../utility/Utility';
import { Store } from '../../../../Redux/Store';
import { fetchEmployee } from '../../../../Redux/Slices/EmployeeListSlice';
import EmployeeListService from '../../../../services/EmployeeListService';
export default class Form16 extends Component{
    selectedUser = [];
    GENERATE_KEYS = {
        GENERATE: 'generate',
        REFRESH: 'refresh'
    }
    constructor(props){
        super(props)
        this.state = {
            timePeriod: {
                toggle: false,
                startDate: moment().format("M") > 3 ? moment().subtract('year',1).format("YYYY-04-01"):moment().subtract('year',2).format("YYYY-04-01"),
                endDate: moment().format("M") > 3 ? moment().format("YYYY-03-31"):moment().subtract('year',1).format("YYYY-03-31"),
                defaultDate: false,
                hasError: false,
                loadingEmployee : false,
                isForm16Generated:false
            },
            exportAll:true,
            users:[],
            gridData:{
                rowData:[],
                columnData:parseVisibleColumnConfig(
                    parseColumnConfig(TableManger.getTableColumns(TABLES.PEOPLE_FORM16) )
                  ),
                filter: [],
                originalData: []
            },
            page: {
                Limit: 20,
                currentPage: 1,
                sort: 'clockIn',
                order: localStorage.getItem("EMP.SORT.ORDER") || 'desc',
                field: localStorage.getItem("EMP.SORT.FIELD") || `_id`,
                searchField: ``,
                searchString: ``,
                totalPage:1
          },
            dropdownUser: {
                limit:1000,
                currentPage:1,
                key:this.GENERATE_KEYS.GENERATE
            }
            
        }
        this.loadGridData(this.state.page)
        this.getUsers(this.state.dropdownUser);//refresh/generate
    }
    componentDidMount() {
        RouteManager.setPresenter(this);
        this.setState({
            ...this.state
        })
    }
    loadGridData(config) {
        //save config
        this.getGridUsers(config)
    }
    async getGridUsers(param) {
        
        EmployeeListService.apiConfig = {...EmployeeListService.apiConfig,...param};
        
        let response = [];
        showLoader()
        const res = await Store.dispatch(fetchEmployee());
        removeLoader()
            if(res && res.error) {
                showToast("Unable to fetch users",TOAST_TYPE.FAILURE);
                this.setState({
                    ...this.state,
                    isLoadingDropDownUser:false
                })
            } else {
                response = res?.payload?.users || [];
                const rowData = prepareRowDataForm16(response,this.getFunctionConfig()) || [];
                const passingData = {
                    columnData: deepClone(this.state.gridData.columnData),
                    rowData,
                    filter: [],
                    originalData: rowData,
                  };
                this.setState({
                    ...this.state,
                    gridData:{
                        ...passingData
                    },
                    page: {
                        ...this.state.page,
                        currentPage: parseInt(res?.payload?.filterConfig?.page),
                        totalPage: parseInt(res?.payload?.filterConfig?.totalPage)
                    },
                    isLoadingDropDownUser:false
                })
            }
    }
    async getUsers(param){
        this.setState({
            ...this.state,
            isLoadingDropDownUser:true
        })
        const year = moment(this.state.timePeriod.startDate).format("YYYY");
        const response = await ReportService.getForm16Users(param, year);
        if (response && response['users']) {
            this.setState({ ...this.state, users: response['users'], isLoadingDropDownUser: false })
        } else {
            this.setState({
                ...this.state,
                isLoadingDropDownUser: false
            })
        }        
        removeLoader()
    }
    getTimePeriod () {
        const dateFormat = TenantService.get(TENANT.DATE_FORMAT);
        const timePeriod = this.state.timePeriod
        return timePeriod.startDate && timePeriod.endDate ? `${moment(timePeriod.startDate).format(dateFormat)} - ${moment(timePeriod.endDate).format(dateFormat)}` : '';
    }
    onExportToggle(){
        if(!this.state.users || this.state.users.length === 0) {
            this.setState({loadingEmployee:true})
        }

        if(!this.state.exportAll) {
            this.selectedUser = []
        }

        this.setState({
            exportAll: !this.state.exportAll
        })
    }
    export(){
        this.setState({...this.state})
        if(!this.state.exportAll && this.selectedUser.length == 0) {
            return
        }
        if(this.state.timePeriod.hasError) {
            return
        }
        let users = []
        this.selectedUser.forEach(ind=>{
            users.push(parseInt(this.state.users[ind].iamUserId))
        })
        const action = !this.state.isForm16Generated ? this.GENERATE_KEYS.GENERATE : this.GENERATE_KEYS.REFRESH
        this.generateAPICall(users,action,true)
    }
    generateAPICall(users, action, isNeedUpdateDropDown) {
        const year = moment(this.state.timePeriod.startDate).format("YYYY");
        showLoader();
        ReportService.generateForm16(
            { ids: users },
            year,
            action
        ).then(response=>{
            showToast(`Form 16 ${action!==this.GENERATE_KEYS.REFRESH ? action+"d" :action+"ed"} successfully`,TOAST_TYPE.SUCCESS)
            this.selectedUser = [];
            this.loadGridData(this.state.page);
            if(isNeedUpdateDropDown) {
                this.getUsers({
                    ...this.state.dropdownUser,
                    key: action
                });
            }
            this.setState({
                exportAll:true,
            })
            removeLoader()
        },error=>{
            removeLoader()
        });
    }
    refreshForm16=(row,index,isRefresh)=>{
        if(row?.rowData?.iamUserId) {
            this.generateAPICall([parseInt(row.rowData.iamUserId)],isRefresh ? this.GENERATE_KEYS.REFRESH : this.GENERATE_KEYS.GENERATE)
        }
    }
    getFunctionConfig() {
        let config = {
          downloadSigned: this.onDocumentDownload,
          refresh: this.refreshForm16
        };
        return config;
    }
    onDocumentDownload = (document, index) => {
        if (document && document.rowData?.documents) {
            const filterStr = `Form-16 ${moment().format("M") > 3 ? moment().subtract('year',1).format("YYYY"):moment().subtract('year',2).format("YYYY")}`
            const newDoc = document?.rowData?.documents?.filter(doc=>doc?.name?.includes(filterStr)) || []
            const documentObject = !Utility.isEmpty(newDoc[index]) ? newDoc[index] : null;
            if (documentObject && documentObject.path) {
              this.downloadDocument(documentObject.path);
            } else {
              showToast("Form 16 is not available to download.", TOAST_TYPE.FAILURE);
            }
          } 
    }
    downloadDocument = (path) => {
        showLoader("Downloading Form16... Please wait");
        AttachmentService.getPresignedURL(path).then(
          (response) => {
            AttachmentService.downloadFile(response).then(
              (response) => {
                removeLoader();
                saveAs(response, getFileName(path));
              },
              (error) => {
                removeLoader();
              }
            );
          },
          (error) => {
            removeLoader();
          }
        );
    }
    render() {
        return (
            <div className="parent-width">
                <DKLabel text="Form 16" className="fw-m fs-l" />
                <div className="row p-v-m p-h-m bg-deskera-secondary mt-l">
                    <DKIcon className="mr-s" src={ic_info_warning} />
                    {i18next.t('FORM16_INFO')}
                </div>
                <div className="bg-white pb-l card-shadow ">
                    <DKLabel text="Generate Form 16 Report" className="fw-m fs-l p-l" />
                    <DKLine className="bg-gray3  " />
                    <div className="d-flex mt-s row row-responsive">
                        <div className="p-h-l web-width-20" >
                            <div className="web-width-100">
                                <div className="row">
                                    <DKInput
                                        title={"Financial Year"}
                                        type={INPUT_TYPE.TEXT}
                                        value={this.getTimePeriod()}
                                        required={true}
                                        readOnly={true}
                                        canValidate={true}
                                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                    />
                                    <DKIcon
                                        className={`mr-s cursor-not-allowed z-index-1 mt-l `}
                                        style={{
                                            marginLeft: "-30px",
                                            filter: "contrast(0.5)"

                                        }}
                                        src={date_range}
                                        onClick={() => {
                                            return;
                                            ///stop action :-> return null
                                            
                                        }}
                                    />
                                    {this.state.timePeriod.toggle && <DKCalendar
                                        className="position-absolute border-m shadow-m bg-white z-index-1 mt-s"
                                        style={{ top: 90, width: 65, "z-index": "1" }}
                                        isDateRange={true}
                                        startDate={this.state.timePeriod.startDate ? new Date(this.state.timePeriod.startDate) : new Date()}
                                        endDate={this.state.timePeriod.endDate ? new Date(this.state.timePeriod.endDate) : new Date()}
                                        onClose={() => {
                                            if (moment(this.state.timePeriod.startDate).diff(this.state.timePeriod.endDate) <= 0 || this.state.timePeriod.endDate == null) {
                                                this.setState({
                                                    timePeriod: {
                                                        toggle: false,
                                                        startDate: this.state.timePeriod.startDate,
                                                        endDate: this.state.timePeriod.endDate,
                                                        defaultDate: false,
                                                        hasError: false
                                                    }
                                                });
                                            } else {
                                                this.setState({
                                                    timePeriod: {
                                                        toggle: false,
                                                        startDate: this.state.timePeriod.startDate,
                                                        endDate: this.state.timePeriod.endDate,
                                                        defaultDate: false,
                                                        hasError: true,
                                                        errorMsg: "End date should not be less than Start date"
                                                    }
                                                });
                                            }
                                        }}
                                        onSelectDate={(start, end) => {
                                            if (start && end) {
                                                let startDate = start 
                                                let endDate = end
                                                if (moment(startDate).diff(endDate) <= 0 || endDate == null) {
                                                    this.setState({
                                                        timePeriod: {
                                                            toggle: false,
                                                            startDate: startDate,
                                                            endDate: endDate,
                                                            defaultDate: false,
                                                            hasError: false
                                                        }
                                                    });
                                                } else {
                                                    this.setState({
                                                        timePeriod: {
                                                            toggle: false,
                                                            startDate: startDate,
                                                            endDate: endDate,
                                                            defaultDate: false,
                                                            hasError: true,
                                                            errorMsg: "End date should not be less than Start date"
                                                        }
                                                    })
                                                }
                                            }
                                        }}
                                    />}
                                </div>
                                {this.state.timePeriod.hasError && <DKLabel
                                    className="mt-xs text-red"

                                    text={this.state.timePeriod.errorMsg}
                                />}
                            </div>
                        </div>
                        <div className="d-flex web-width-30 justify-content-center align-items-center" style={{ marginTop: 18 }}>
                            <DKLabel
                                className="text-align-left ml-s mr-l"
                                text={"Generate"}
                            />
                            <Toggle
                                className="border-n"
                                isOn={this.state.isForm16Generated}
                                onChange={() => {
                                    this.selectedUser = [];
                                    this.getUsers({
                                        ...this.state.dropdownUser,
                                        key: this.state.isForm16Generated ? this.GENERATE_KEYS.GENERATE : this.GENERATE_KEYS.REFRESH
                                    });
                                    this.setState({
                                        isLoadingDropDownUser: true,
                                        isForm16Generated: !this.state.isForm16Generated
                                    })
                                }}
                            />
                            <DKLabel
                                className="text-align-left ml-l mr-l fw-m"
                                text={"Regenerate"}
                            />
                        </div>
                        <div className="d-flex web-width-30 justify-content-center align-items-center" style={{ marginTop: 18 }}>
                            <DKLabel
                                className="text-align-left ml-s mr-l"
                                text={"All Employees"}
                            />
                            <Toggle
                                className="border-n"
                                isOn={!this.state.exportAll}
                                onChange={() => this.onExportToggle()}
                            />
                            <DKLabel
                                className="text-align-left ml-l mr-l fw-m"
                                text={"Specific Employees"}
                            />
                        </div>
                        <div className="web-width-20 mobile-horizontal-width padding-top-mobile">
                            {(this.state.isLoadingDropDownUser) && <div style={{ marginLeft: "-120px", marginBottom: "-22px" }}><DKSpinner className="" /></div>}
                            <DKInput
                                title="Employees"
                                value={this.selectedUser}
                                type={INPUT_TYPE.MULTI_SELECT}
                                required={!this.state.exportAll}
                                canValidate={!this.state.exportAll}
                                readOnly={this.state.exportAll}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                options={this.state.users.map(res => `${res.firstName} ${res.lastName}`)}
                                errorMessage="Please select employees"
                                onChange={(value) => {
                                    this.selectedUser = value
                                }}
                            />
                        </div>
                        <div className="mb-xs m-h-l " style={{ marginTop: '22px' }}>
                            <DKButton
                                style={{ minWidth: 116 }}
                                title={!this.state.isForm16Generated ? "Generate" : "Regenerate"}
                                icon={DKIcons.white.ic_export}
                                className="bg-app text-white"
                                onClick={() => {
                                    this.export();
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div
                    className="column parent-width flex-1  "
                    style={{ minHeight: 400 }}
                >
                    <div className="column parent-width mb-s position-relative flex-1 ">
                        <DataGridHolderPayroll
                            tableName={TABLES.PEOPLE_FORM16}
                            displayTableName={TABLE_DISPLAY_NAME[TABLES.PEOPLE_FORM16]}
                            allowColumnEdit={false}
                            allowColumnDelete={false}
                            allowColumnShift={false}
                            allowSearch={false}
                            allowFilter={false}
                            onRowDelete={() => { }}
                            onRowEdit={() => { }}
                            allowRowAdd={true}
                            addButtonConfig={[]}
                            allowRowEdit={false}
                            allowDataExport={false}
                            gridData={this.state.gridData}
                            onSearch={() => { }}
                            onColumnAdd={() => { }}
                            onFilter={() => { }}
                            filter={[]}
                            onRowAdd={() => { }}
                            
                            onPaginationClick={(requestedPageNumber) => {
                                const config = {
                                    ...this.state.page,
                                    currentPage: requestedPageNumber,
                                };
                                  this.loadGridData(config);
                            }}
                            currentPage={this.state.page.currentPage}
                            totalPageCount={this.state.page.totalPage}
                            isActionEnabled={true}
                            contextMenu={true}
                            onStatusChange={() => { }}
                            isMenuVisible={false}
                            onRowUpdate={() => { }}
                            onDocumentDownloadSigned={(data, isSigned) => {
                                  this.onDocumentDownload(data, isSigned);
                            }}
                        />
                    </div>
                </div>
            </div>
        )
    }
}
